module.exports = __webpack_public_path__ + "img/responsive hospitium-05.8bd42f22.jpg";